import {Expressions} from '@packages/systems/wfdl';
import {type ExpressionElement, EElement} from '@packages/systems/wfdl-ast';
import type {UniqueIdsState} from '@packages/utilities/platform-instantiateExpressionWithUniqueIds';
import {instantiateExpressionWithUniqueIds} from '@packages/utilities/platform-instantiateExpressionWithUniqueIds';

// Updates element and its children ids by propagating firstId through the element tree
export function refreshElementIds(
  element: ExpressionElement,
  firstId: string
): {
  idsState: UniqueIdsState;
  refreshedElement: ExpressionElement;
} {
  const [idsState, updatedExpression] = instantiateExpressionWithUniqueIds(
    EElement(element)
  )(firstId);
  const refreshedElement = Expressions.getElement(updatedExpression) || element;

  return {idsState, refreshedElement};
}
